import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './CompanyInformation.css';
import { Store } from '../../../stores';
import { IATextField } from '../../../../textField/TextField';
import { LocalizationService } from '../../../../../services/LocalizationService';
import { IAButton } from '../../../../button/Button';
//import PlayService from '../../../../../services/PlayService';
import { Helper } from '../../../../../Helper';
import { IADropDown } from '../../../../dropDown/DropDown';
import PlayService from '../../../../../services/PlayService';

export interface IProps {
  showButtonAtTheBottom?: boolean;
  store?: Store;
  onSaved: () => void;
}

export interface IState {
  loading: boolean;
}

@inject('store')
@observer
export class CompanyInformation extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      loading: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    if (this.props.store.contactInformation == undefined) {
      this.getContactInformation();
    }
  }

  private getContactInformation(): void {
    PlayService.getContactInformation(this.props.store.environment, this.props.store.token, this.props.store.tenantId).then((contactInformation) => {
      if (contactInformation) {
        this.props.store.contactInformation = contactInformation;
      } else {
        this.props.store.contactInformation = {
          companyName: "",
          contactEmail: "",
          contactName: "",
          contactPhoneNumber: "+45",
          address: "",
          vatNumber: "",
          country: "DK"
        };
      }
      this.setState({ loading: false });
    });
  }

  private save(): void {
    this.setState({ loading: true });
    if (this.formIsValid()) {
      if (this.props.store.contactInformation?.id) {
        PlayService.updateContactInformation(this.props.store.environment, this.props.store.token, this.props.store.tenantId, this.props.store.contactInformation).then(() => {
          this.setState({ loading: false }, () => this.props.onSaved());
        });
      } else {
        PlayService.createContactInformation(this.props.store.environment, this.props.store.token, this.props.store.tenantId, this.props.store.contactInformation).then(() => {
          // Create license
          PlayService.updateScreenLicense(this.props.store.environment, this.props.store.token, this.props.store.tenantId, 1).then(() => {
            this.props.store.licensedNumberOfPlayers = 1;
            this.setState({ loading: false }, () => this.props.onSaved());
          });
        });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  private formIsValid(): boolean {
    if (this.props.store.contactInformation &&
      this.props.store.contactInformation?.address &&
      this.props.store.contactInformation?.companyName &&
      this.props.store.contactInformation?.contactEmail && this.validEmail(this.props.store.contactInformation?.contactEmail) &&
      this.props.store.contactInformation?.contactName &&
      this.props.store.contactInformation?.contactPhoneNumber && this.validPhoneNumber(this.props.store.contactInformation?.contactPhoneNumber) &&
      this.props.store.contactInformation?.country &&
      this.props.store.contactInformation?.vatNumber
    ) {
      if (!this.props.store.contactInformation?.country) {
        this.props.store.contactInformation.country = "DK";
      }
      return true;
    } else {
      return false;
    }
  }

  private validPhoneNumber(phoneNumber: string): boolean {
    const phoneRegex = /^\+/;
    return phoneRegex.test(phoneNumber);
  }

  private validEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  public render(): JSX.Element {
    return (
      <div className={styles.IA_companyInformation}>
        {!this.props.showButtonAtTheBottom &&
          <IAButton
            label={this.localizationService.strings.PlayAdmin_Update?.toUpperCase()}
            buttonColor={this.props.store.highlightColor}
            darkMode={this.props.store.darkMode}
            onClick={() => this.save()}
            borderRadius={5}
            disbaled={!this.formIsValid()}
            showSpinner={this.state.loading}
            style={{
              float: "right",
              position: "relative",
              marginTop: 20
            }}
          />
        }
        <IATextField
          label={this.localizationService.strings.PlayAdmin_CompanyName}
          text={this.props.store.contactInformation?.companyName}
          required
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          borderRadius={5}
          labelStyle={{
            textTransform: "uppercase",
            fontSize: 12,
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(company: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.companyName = company;
            this.forceUpdate();
          }}
        />
        <IATextField
          label={this.localizationService.strings.PlayAdmin_ContactPerson}
          text={this.props.store.contactInformation?.contactName}
          required
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          borderRadius={5}
          labelStyle={{
            textTransform: "uppercase",
            fontSize: 12,
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(contactName: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.contactName = contactName;
            this.forceUpdate();
          }}
        />
        {/* address uses a plain textarea instead of IATextField to allow multiline input */}
        <div
          style={{
            marginTop: 15,
            float: "left",
            width: "100%",
          }}
        >
          <div
            style={{
              float: "left",
              textTransform: "uppercase",
              fontSize: 12,
            }}
          >
            {this.localizationService.strings.PlayAdmin_Address}
            <span style={{ color: "red" }}>*</span>
          </div>
          <textarea
            value={this.props.store.contactInformation?.address || ""}
            required
            style={{
              width: "100%",
              marginTop: 7,
              padding: 10,
              borderRadius: 5,
              height: 80,
              boxSizing: "border-box",
              resize: "vertical",
              backgroundColor: this.props.store.darkMode ? "#414141" : "#ffffff",
              color: this.props.store.darkMode ? "#ffffff" : "#000000",
              border: this.props.store.darkMode ? "none" : "1px solid #dddddd"
            }}
            onChange={(event) => {
              if (this.props.store.contactInformation == undefined) {
                this.props.store.contactInformation = {};
              }
              this.props.store.contactInformation.address = event.target.value;
              this.forceUpdate();
            }}
          />
        </div>
        <IADropDown
          label={this.localizationService.strings.PlayAdmin_Country?.toUpperCase()}
          required
          selectedOption={this.props.store.contactInformation?.country ? this.props.store.contactInformation?.country : "DK"}
          options={Helper.getCountryCodes()}
          borderRadius={5}
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          style={{
            marginTop: 20,
            float: "left",
            width: "100%",
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(country: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.country = country;
            this.forceUpdate();
          }}
        />
        <IATextField
          label={this.localizationService.strings.Phonebook_Phone}
          text={this.props.store.contactInformation?.contactPhoneNumber}
          required
          placeholder={"+XXXXXXXXXX"}
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          borderRadius={5}
          labelStyle={{
            textTransform: "uppercase",
            fontSize: 12,
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(phone: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.contactPhoneNumber = phone;
            this.forceUpdate();
          }}
        />
        {this.props.store.contactInformation?.contactPhoneNumber &&
          !this.validPhoneNumber(this.props.store.contactInformation.contactPhoneNumber) &&
          <div style={{ color: "#ff4444", fontSize: 12, marginTop: 5, float: "left" }}>
            {this.localizationService.strings.PlayAdmin_PhoneNumberErrorMessage}
          </div>
        }
        <IATextField
          label={this.localizationService.strings.PlayAdmin_Email}
          text={this.props.store.contactInformation?.contactEmail}
          required
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          borderRadius={5}
          labelStyle={{
            textTransform: "uppercase",
            fontSize: 12,
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(email: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.contactEmail = email;
            this.forceUpdate();
          }}
        />
        {this.props.store.contactInformation?.contactEmail &&
          !this.validEmail(this.props.store.contactInformation.contactEmail) &&
          <div style={{ color: "#ff4444", fontSize: 12, marginTop: 5, float: "left" }}>
            {this.localizationService.strings.PlayAdmin_EmailErrorMessage}
          </div>
        }
        <IATextField
          label={this.localizationService.strings.PlayAdmin_VatNumber}
          text={this.props.store.contactInformation?.vatNumber}
          required
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          borderRadius={5}
          labelStyle={{
            textTransform: "uppercase",
            fontSize: 12,
            color: this.props.store.darkMode ? "#ffffff" : "#000000"
          }}
          onChange={(vat: string) => {
            if (this.props.store.contactInformation == undefined) {
              this.props.store.contactInformation = {};
            }
            this.props.store.contactInformation.vatNumber = vat;
            this.forceUpdate();
          }}
        />
        {this.props.showButtonAtTheBottom &&
          <IAButton
            label={this.localizationService.strings.PlayAdmin_Update?.toUpperCase()}
            buttonColor={this.props.store.highlightColor}
            darkMode={this.props.store.darkMode}
            onClick={() => this.save()}
            borderRadius={5}
            disbaled={!this.formIsValid()}
            showSpinner={this.state.loading}
            style={{
              float: "left",
              position: "relative",
              marginTop: 20
            }}
          />
        }
      </div>
    );
  }


}